module.exports = "/_next/static/images/ico-tel-db4af5f12caf9c63908fcde6782a7eba.svg";